import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import LocalizedLink from '../../components/LocalizedLink';
import BusinessWeeklyItem from '../../components/BusinessWeeklyItem';
import Paginator from '../../components/Paginator';
import {
  Breadcrumb,
  BreadcrumbItem,
  Col,
  Container,
  Row,
  FormGroup,
  Input,
  Button,
  Form,
  Card,
  CardBody,
} from 'reactstrap';
import Select from '../../components/Select';
import Loader from '../../components/Loader';
import { ROUTES } from '../../constants/routes';
import { LINK_LABELS } from '../../constants/labels';
import {
  typesLabels,
  typesIcons,
  bwLabels,
  types,
} from '../../constants/document';
import { getSearchDocumentLink } from '../../utils';

const searchResultsPerPage = 50;

const CATEGORY_TOPICS = [
  {
    label: 'Deals & Kinyanim',
    searchTerm: 'kinyan|deal',
    icon: 'fa-handshake',
  },
  { label: 'Partnerships', searchTerm: 'partnership', icon: 'fa-users' },
  {
    label: 'Services & Brokers',
    searchTerm: 'broker|service',
    icon: 'fa-briefcase',
  },
  {
    label: 'Competition & Ethics',
    searchTerm: 'competition|ethic',
    icon: 'fa-balance-scale',
  },
  { label: 'Loans', searchTerm: 'loan', icon: 'fa-hand-holding-usd' },
  { label: 'Ribbis', searchTerm: 'ribbis', icon: 'fa-percent' },
  {
    label: 'Shabbos & Yom Tov',
    searchTerm: 'shabbos|yom tov',
    icon: 'fa-candle-holder',
    useLibraryIcon: true,
  },
  {
    label: 'Dayanim - Beis Din',
    searchTerm: 'beis din|dayan',
    icon: 'fa-gavel',
  },
  {
    label: 'Real estate & Property Partnerships',
    searchTerm: 'real estate|property',
    icon: 'fa-home',
  },
  { label: 'Rentals', searchTerm: 'rental', icon: 'fa-key' },
  {
    label: 'Tzedakah & Maaser',
    searchTerm: 'tzedak|maaser',
    icon: 'fa-hand-holding-heart',
  },
  {
    label: 'Employment & Service Relationships',
    searchTerm: 'employment|employee',
    icon: 'fa-user-tie',
  },
  {
    label: 'Damages & Geneiva',
    searchTerm: 'damage|geneiv',
    icon: 'fa-exclamation-triangle',
  },
  {
    label: 'Shomrim & Guardianship',
    searchTerm: 'shomer|shomr|guardian',
    icon: 'fa-shield-alt',
  },
  {
    label: 'Contracts & Shtaros',
    searchTerm: 'contract|shtar',
    icon: 'fa-file-signature',
  },
  {
    label: 'Yerusha & Estate Planning',
    searchTerm: 'yerusha|estate',
    icon: 'fa-scroll',
  },
  {
    label: 'Hashavas Aveidah',
    searchTerm: 'aveida|aveidah',
    icon: 'fa-search-location',
  },
];

export default class BWArchive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterCategory: null,
      filterSearch: '',
      filterNumber: null,
      activeCategory: null,
      activeSearchTerm: null,
      searchPage: 1,
    };
    this.getList = this.getList.bind(this);
  }

  componentDidMount() {
    const { selectedLang, getList, getCategories } = this.props;
    getList({ lang: selectedLang });
    getCategories('BUSINESS_WEEKLY');
  }

  componentWillUnmount() {
    this.props.resetSearch();
  }

  getList({ page = 1 }) {
    const { selectedLang, getList } = this.props;
    const { filterSearch, filterCategory, filterNumber } = this.state;
    const categoryId = filterCategory && filterCategory.value;
    getList({
      page,
      lang: selectedLang,
      filter: {
        filterSearch,
        filterCategory: categoryId,
        filterNumber,
      },
    });
  }

  handleChange = e => {
    const value = e.target.value === '-' ? '' : e.target.value;
    this.setState({
      [e.target.id]: value,
    });
  };

  handleSelectChange = value => {
    this.setState(
      {
        filterCategory: value,
      },
      () => {
        this.handleSearch();
      },
    );
  };

  handleSearch = () => {
    const { filterSearch, filterCategory, filterNumber } = this.state;
    const { selectedLang, getList } = this.props;
    const categoryId = filterCategory && filterCategory.value;
    getList({
      lang: selectedLang,
      filter: {
        filterSearch,
        filterCategory: categoryId,
        filterNumber,
      },
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    this.handleSearch();
  };

  handleCategoryClick = topic => {
    const { search, resetSearch } = this.props;
    const { activeCategory } = this.state;

    if (activeCategory === topic.label) {
      this.setState({
        activeCategory: null,
        activeSearchTerm: null,
        searchPage: 1,
      });
      resetSearch();
      return;
    }

    this.setState({
      activeCategory: topic.label,
      activeSearchTerm: topic.searchTerm,
      searchPage: 1,
    });
    search({ searching: topic.searchTerm, page: 1, reset: true });
  };

  handleClearCategory = () => {
    this.setState({
      activeCategory: null,
      activeSearchTerm: null,
      searchPage: 1,
    });
    this.props.resetSearch();
  };

  loadMoreSearchResults = () => {
    const { search } = this.props;
    const { activeSearchTerm, searchPage } = this.state;
    const nextPage = searchPage + 1;
    this.setState({ searchPage: nextPage });
    search({ searching: activeSearchTerm, page: nextPage });
  };

  renderSearchResult(item) {
    const { selectedLang } = this.props;
    let link;
    if (item.Document) {
      link = getSearchDocumentLink(item.Document);
      return (
        <LocalizedLink to={link}>
          <p className="my-0 h4">{item.title}</p>
          <div className="mt-1 text-muted text-sm">
            <span className="mr-2">{typesIcons[item.Document.type]}</span>
            {item.Document.type === types.BUSINESS_WEEKLY
              ? bwLabels[selectedLang]
              : typesLabels[item.Document.type]}
          </div>
        </LocalizedLink>
      );
    }

    if (item.BusinessWeekly) {
      return (
        <LocalizedLink
          to={`${ROUTES.BUSINESS_WEEKLY_ITEM_PARAM}${item.BusinessWeekly.id}`}
        >
          <p className="my-0 h4">{item.title}</p>
          <div className="mt-1 text-muted text-sm">
            <span className="mr-2">{typesIcons[types.BUSINESS_WEEKLY]}</span>
            {bwLabels[selectedLang]}
          </div>
        </LocalizedLink>
      );
    }

    if (item.categoryId) {
      return (
        <LocalizedLink to={getSearchDocumentLink(item)}>
          <p className="my-0 h4">{item.lang[selectedLang].title}</p>
          <div className="mt-1 text-muted text-sm">
            <span className="mr-2">{typesIcons[item.type]}</span>
            {typesLabels[item.type]}
          </div>
          <div className="text-muted text-sm">
            found by <span className="text-default">Category</span>:&nbsp;
            {item.categoryLabel}
          </div>
        </LocalizedLink>
      );
    }
  }

  renderCategoryButtons() {
    const { activeCategory } = this.state;

    return CATEGORY_TOPICS.map(topic => {
      const isActive = activeCategory === topic.label;

      return (
        <Button
          key={`cat-btn-${topic.label}`}
          className="m-1 text-left"
          color={isActive ? 'primary' : 'secondary'}
          outline={!isActive}
          size="sm"
          onClick={() => this.handleCategoryClick(topic)}
          style={{
            minWidth: '200px',
            fontWeight: isActive ? 'bold' : 'normal',
          }}
        >
          {topic.useLibraryIcon ? (
            <FontAwesomeIcon
              icon={['fas', topic.icon.replace(/^fa-/, '')]}
              className="mr-2"
              style={{ width: '1em' }}
            />
          ) : (
            <i className={`fas ${topic.icon} mr-2`} style={{ width: '1em' }} />
          )}
          {topic.label}
        </Button>
      );
    });
  }

  renderSearchResults() {
    const { searchResults, searchResultsAmount, searchLoading } = this.props;
    const { activeCategory, searchPage } = this.state;
    const showLoadMore =
      searchResultsPerPage * searchPage < searchResultsAmount;

    return (
      <>
        <Row className="mb-3 align-items-center">
          <Col>
            <h4 className="mb-0">
              Results for:{' '}
              <span className="text-primary">{activeCategory}</span>
              {searchResults.length > 0 && searchResultsAmount > 0 && (
                <small className="text-muted ml-2">
                  (Showing {searchResults.length} of {searchResultsAmount})
                </small>
              )}
            </h4>
          </Col>
          <Col xs="auto">
            <Button color="link" size="sm" onClick={this.handleClearCategory}>
              <i className="fas fa-times mr-1" />
              Clear
            </Button>
          </Col>
        </Row>
        <Row>
          {searchLoading && !searchResults.length && (
            <Col className="py-5 display-4 text-muted text-center">
              Searching...
            </Col>
          )}
          {!searchLoading && (!searchResults || !searchResults.length) && (
            <Col>
              <h3 className="mx-3 py-6">No items found</h3>
            </Col>
          )}
          {searchResults.map((result, i) => (
            <Col sm={6} key={genSearchKey(result, i)}>
              <Card>
                <CardBody>{this.renderSearchResult(result)}</CardBody>
              </Card>
            </Col>
          ))}
        </Row>
        {showLoadMore && !searchLoading && searchResultsAmount > 0 && (
          <Row className="justify-content-center mb-2">
            <small className="text-muted">
              Showing {searchResults.length} of {searchResultsAmount} results
            </small>
          </Row>
        )}
        <Row className="justify-content-center">
          {showLoadMore && !searchLoading && (
            <Button onClick={this.loadMoreSearchResults} color="info">
              Load More
            </Button>
          )}
          {searchLoading && searchResults.length > 0 && (
            <Col className="text-center py-2">
              <i className="text-default fas fa-spinner fa-pulse" />
            </Col>
          )}
        </Row>
      </>
    );
  }

  renderBWList() {
    const { list, listCount, categories, selectedLang } = this.props;
    const { filterSearch, filterCategory, filterNumber } = this.state;

    const categoryOptions = (categories || []).map(cat => ({
      label:
        cat.title && cat.title[selectedLang]
          ? cat.title[selectedLang]
          : cat.title?.en || `Category ${cat.id}`,
      value: cat.id,
    }));

    return (
      <>
        <Form onSubmit={this.handleSubmit}>
          <Row className="align-items-center">
            <Col>
              <FormGroup>
                <label className="form-control-label" htmlFor="filterCategory">
                  Category
                </label>
                <Select
                  id="filterCategory"
                  type="select"
                  value={filterCategory}
                  onChange={this.handleSelectChange}
                  options={categoryOptions}
                  placeholder="Select category"
                  isClearable
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <label className="form-control-label" htmlFor="filterNumber">
                  Issue number
                </label>
                <Input
                  id="filterNumber"
                  placeholder="Issue number"
                  type="number"
                  value={filterNumber}
                  onChange={this.handleChange}
                />
              </FormGroup>
            </Col>
            <Col>
              <FormGroup>
                <label className="form-control-label" htmlFor="filterSearch">
                  Narrow by word
                </label>
                <Input
                  id="filterSearch"
                  placeholder="Any"
                  type="text"
                  value={filterSearch}
                  onChange={this.handleChange}
                />
              </FormGroup>
            </Col>
            <Col md={1}>
              <Button
                className="btn-icon btn-2 btn-block mt-2"
                color="primary"
                type="submit"
              >
                <span className="btn-inner--icon">
                  <i className="fas fa-search" />
                </span>
              </Button>
            </Col>
          </Row>
        </Form>
        <Row className="py-5">
          {!list ||
            (!list.length && <h3 className="mx-3 py-6">No items found</h3>)}
          {list &&
            list.map(item => (
              <Col key={`bw-item-${item.id}`} md={6}>
                <BusinessWeeklyItem item={item} />
              </Col>
            ))}
        </Row>
        <Paginator getItems={this.getList} amount={listCount} />
      </>
    );
  }

  render() {
    const { loading } = this.props;
    const { activeCategory } = this.state;

    return (
      <>
        {loading && <Loader type="fixed" />}
        <section className="bg-gradient-info py-5">
          <Container>
            <Breadcrumb listClassName="breadcrumb-dark breadcrumb-links pb-2">
              <BreadcrumbItem>
                <LocalizedLink to={ROUTES.HOME}>
                  {LINK_LABELS.HOME.EN}
                </LocalizedLink>
              </BreadcrumbItem>
              <BreadcrumbItem aria-current="page" className="active">
                {LINK_LABELS.BUSINESS_WEEKLY.EN}
              </BreadcrumbItem>
            </Breadcrumb>
            <Row className="align-items-stretch">
              <Col lg={4} xs={12}>
                <h1 className="display-2 text-white mb-0">
                  {LINK_LABELS.ARCHIVE.EN}
                </h1>
              </Col>
            </Row>
          </Container>
        </section>
        <section>
          <Container className="py-6">
            <Row>
              <Col md={3}>
                <h4 className="mb-3">Search By Category</h4>
                <div className="d-flex flex-wrap">
                  {this.renderCategoryButtons()}
                </div>
              </Col>
              <Col md={9}>
                {activeCategory
                  ? this.renderSearchResults()
                  : this.renderBWList()}
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }
}

function genSearchKey(searchResult, index) {
  let ident = '';
  if (searchResult.Document) {
    ident = `doc-${searchResult.Document.type}-${searchResult.Document.id}`;
  }
  if (searchResult.BusinessWeekly) {
    ident = `bw-${searchResult.BusinessWeekly.id}`;
  }
  if (searchResult.categoryId) {
    ident = `byCat-${searchResult.type}-${searchResult.id}`;
  }
  return `search-result-${ident}-${index}`;
}
